import React, { useMemo } from "react";
import { IconButton } from "../IconButton/IconButton";
import styles from "./PagesPreview.module.scss";
import classNames from "classnames";
import { metrics } from "../../analytics/events";
export var SliderArrow = function (_a) {
    var _b, _c;
    var direction = _a.direction, range = _a.range, _d = _a.currentSlide, currentSlide = _d === void 0 ? 0 : _d, _e = _a.slideCount, slideCount = _e === void 0 ? 0 : _e, onClick = _a.onClick;
    var disabled = useMemo(function () {
        if (direction === "prev") {
            return currentSlide === 0;
        }
        else {
            return currentSlide === slideCount - 1;
        }
    }, [currentSlide, slideCount, direction]);
    return (React.createElement("div", { className: classNames(styles.sliderArrowHolder, (_b = {},
            _b[styles.prev] = direction === "prev",
            _b[styles.next] = direction === "next",
            _b)) },
        React.createElement(IconButton, { icon: direction === "prev"
                ? require("@/public_assets/button_arrow_left.png")
                : require("@/public_assets/button_arrow_right.png"), iconHover: direction === "prev"
                ? require("@/public_assets/button_arrow_left_hover.png")
                : require("@/public_assets/button_arrow_right_hover.png"), 
            // outline
            className: classNames(styles.sliderArrow, (_c = {},
                _c[styles.prev] = direction === "prev",
                _c[styles.next] = direction === "next",
                _c)), onClick: function () {
                onClick === null || onClick === void 0 ? void 0 : onClick();
                if (direction === "prev") {
                    metrics.clickOnPreviewPrevious();
                }
                else {
                    metrics.clickOnPreviewNext();
                }
            }, disabled: disabled }),
        range && (React.createElement("div", { className: styles.range },
            range[0],
            " - ",
            range[1]))));
};
